export default __webpack_public_path__ + "static/media/star_full.7ed45547.svg";